import { getStyledElement } from "@/helpers";
import { H1 } from "../h";

export const PageTitle = getStyledElement(H1)({
  styles: ({ theme }) => ({
    color: theme.colors.lightPrx
  })
});
